import refineriesApi from '@/api/refineries';

const state = {
  refineries: [],
  reconciliation: { unpaidAgreements: [], ownedGoldByRefinery: [], totalUnpaidAmount: 0, totalOwnedPureGram: 0, totalYesterdayOwnedPureGram: 0 },
  canView: false,
};

const getters = {
  refineries: (s) => s.refineries,
  reconciliation: (s) => s.reconciliation,
  canViewRefinery: (s) => s.canView,
};

const actions = {
  async getRefineries({ commit }) {
    const { data } = await refineriesApi.getRefineries();
    commit('setRefineries', data || []);
    return data;
  },
  async createRefinery(_ctx, payload) {
    const { data } = await refineriesApi.createRefinery(payload);
    return data;
  },
  async updateRefinery(_ctx, { id, payload }) {
    const { data } = await refineriesApi.updateRefinery(id, payload);
    return data;
  },
  async deleteRefinery(_ctx, id) {
    await refineriesApi.deleteRefinery(id);
  },
  async getCanView({ commit }) {
    try {
      const { data } = await refineriesApi.canView();
      commit('setCanView', !!data);
      return !!data;
    } catch (e) {
      commit('setCanView', false);
      return false;
    }
  },
  async getReconciliation({ commit }) {
    const { data } = await refineriesApi.getReconciliation();
    commit('setReconciliation', data || state.reconciliation);
    return data;
  },
  async recordIntake(_ctx, payload) {
    const { data } = await refineriesApi.recordIntake(payload);
    return data;
  },
  async giveGold(_ctx, payload) {
    const { data } = await refineriesApi.giveGold(payload);
    return data;
  },
  async getHistory(_ctx, payload) {
    const p = payload || {};
    const { data } = await refineriesApi.getHistory(p.refineryId, p.startDate, p.endDate, p.barcode);
    return data || [];
  },
  async getPendingInventory() {
    const { data } = await refineriesApi.getPendingInventory();
    return data || { groups: [] };
  },
};

const mutations = {
  setRefineries: (s, v) => { s.refineries = v; },
  setReconciliation: (s, v) => { s.reconciliation = v; },
  setCanView: (s, v) => { s.canView = v; },
};

export default { namespaced: true, state, getters, actions, mutations };
